<h1 mat-dialog-title>Ειδοποίηση Συστήματος</h1>

<mat-dialog-content>
  Παρουσιάστηκε κάποιο σφάλμα κατά την εκτέλεση κάποιας διεργάσιας του συστήματος.
</mat-dialog-content>

<mat-dialog-actions>
  <button color="primary" mat-flat-button (click)="closeDialog()">ΟΚ</button>
</mat-dialog-actions>
